import { RunnersPromo } from './RunnersPromo';

// NOTE: swap out components here to showcase new features!

export function NewFeatures() {
  return <RunnersPromo />;
}
